import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api";
import { C } from "@/theme";
import { Field, OptionSelector, Picker, FormScreen } from "@/ui";

export default function TestForm() {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const [form, setForm] = useState({ rider_id: "", date: "", result: "Gold", notes: "" });
  const ridersQ = useQuery({ queryKey: ["riders"], queryFn: () => api.get("/riders") });
  const save = useMutation({
    mutationFn: () => api.post("/tests", { rider_id: form.rider_id, test_type: "RoSPA Advanced Test", date: form.date || undefined, result: form.result, notes: form.notes }),
    onSuccess: () => { qc.invalidateQueries({ queryKey: ["tests"] }); qc.invalidateQueries({ queryKey: ["riders"] }); qc.invalidateQueries({ queryKey: ["dashboard"] }); navigate(-1); },
  });
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  return (
    <FormScreen title="New Test Result" onClose={() => navigate(-1)} onSave={() => save.mutate()} saving={save.isPending} saveDisabled={!form.rider_id}>
      <Picker label="Rider" testID="test-rider-picker" placeholder="Select rider" searchable value={form.rider_id} onSelect={set("rider_id")} options={(ridersQ.data ?? []).map((r) => ({ key: r.id, label: r.name }))} />
      <Field label="Test Type" value="RoSPA Advanced Test" disabled testID="test-type" />
      <Field label="Pass Date" value={form.date} onChange={set("date")} type="date" testID="test-date" />
      <OptionSelector label="Result" options={["Gold", "Silver", "Bronze", "Fail"]} value={form.result} onChange={set("result")} testID="test-result" />
      <p style={{ color: C.muted }} className="text-[13px] italic">{form.result === "Fail" ? "A fail does not set an expiry date." : "A pass is valid for 3 years. The rider's profile shows the expiry date and reminders appear as it nears (club setting: 6 and 3 months before)."}</p>
      <Field label="Notes" value={form.notes} onChange={set("notes")} multiline testID="test-notes" />
    </FormScreen>
  );
}
